import React from 'react';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectSelectedShift } from '../../redux/shifts/shiftsSlice';
import { useShiftNotes } from '../../utils/Hooks/shifts/useShiftNotes';
import { NotesContainer, StyledBox, StyledTextField } from './Notes.styles';

/**
 * Notes Component
 *
 * A component for displaying and editing notes with auto-save functionality.
 *
 * @param {Object} props
 * @param {string} props.title - The title to display above the notes
 * @param {string} props.placeholder - Placeholder text for the textarea
 * @param {boolean} props.disabled - Whether the notes are editable
 */
const Notes = ({ title, placeholder, disabled }) => {
  const shift = useSelector(selectSelectedShift);
  const shiftID = shift?.id;
  const { updatedNotes, handleSaveNote, handleNoteBlur } = useShiftNotes({
    shiftID,
    shift,
  });

  return (
    <NotesContainer>
      <Typography variant="h6">{title}</Typography>
      <StyledBox>
        <StyledTextField
          value={updatedNotes || ''}
          onChange={(e) => handleSaveNote(e.target.value)}
          onBlur={handleNoteBlur}
          placeholder={placeholder}
          disabled={disabled}
          multiline
        />
      </StyledBox>
    </NotesContainer>
  );
};

export default Notes;
